import React from 'react';

const HeatmapChart = ({ heatmapData }) => {
  const allCompetencyValues = heatmapData.length > 0
    ? heatmapData.flatMap(row =>
        Object.keys(row).filter(key => key !== 'nome_pessoa').map(key => row[key])
      ).filter(value => value !== undefined && value !== null)
    : [];

  const minValue = allCompetencyValues.length > 0 ? Math.min(...allCompetencyValues) : 0;
  const maxValue = allCompetencyValues.length > 0 ? Math.max(...allCompetencyValues) : 100;

  const interpolateColor = (value, min, max) => {
    if (value === undefined || value === null) {
      return '#e0e0e0';
    }
    if (min === max) {
      return '#007bff';
    }

    const ratio = (value - min) / (max - min);
    const hueMin = 0;
    const hueMax = 120;

    const hue = hueMin + ratio * (hueMax - hueMin);
    return `hsl(${hue}, 70%, 50%)`;
  };

  const getColorByValue = (value) => interpolateColor(value, minValue, maxValue);

  return (
    <div className="bg-white p-4 rounded-lg shadow">
      <h3 className="text-lg font-semibold mb-4">Mapa de Calor de Competências</h3>
      <div className="overflow-x-auto">
        <table className="min-w-full">
          <thead>
            <tr className="bg-gray-100">
              <th className="px-4 py-2 text-left">Nome</th>
              {heatmapData.length > 0 &&
                Object.keys(heatmapData[0]).filter(key => key !== 'nome_pessoa').map(key => (
                <th key={key} className="px-4 py-2 text-center">
                  {key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {heatmapData.map((row, index) => (
              <tr key={index} className="border-b">
                <td className="px-4 py-2 font-medium">{row.nome_pessoa}</td>
                {Object.keys(row).filter(key => key !== 'nome_pessoa').map(key => (
                  <td key={key} className="px-4 py-2 text-center" style={{ backgroundColor: getColorByValue(row[key]), color: 'white' }}>
                    {row[key] !== null && row[key] !== undefined ? parseFloat(row[key]).toFixed(2) : ''}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default HeatmapChart;